/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getIsAuthenticatedStatus } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';

const useStyles = makeStyles((theme) => ({
    pageContainer: {
        marginTop: '3vh',
        [theme.breakpoints.down('sm')]: {
            width: '100vw !important'
        }
    },
    pageContainerCopy: {
        fontSize: '1rem !important',
        textAlign: 'center',
    }
}));

const RemindersOptOutPage = () => {
    const classes = useStyles();
    const isAuthenticated = useSelector(getIsAuthenticatedStatus);

    useEffect(() => {
        if (document?.getElementById('mobile-main-container')) {
            document.getElementById('mobile-main-container').style.width = '100vw';
        }
        const timeout = setTimeout(() => {
            if (window?.location) window.location.replace('https://www.1800flowers.com');
        }, 5000);
        return () => clearTimeout(timeout)
    }, [])

    return (
        <div style={{ width: isAuthenticated ? '80%' : '100%' }} className={classes.pageContainer}>
            <p className={classes.pageContainerCopy}>
                Your reminder has been turned off.
                <br />
                You are now being redirected to <a style={{ fontSize: '1rem' }} href='https://www.1800flowers.com'>www.1800flowers.com.</a>
            </p>
        </div>
    )
};

export default RemindersOptOutPage;